import { createAction } from 'redux-actions';

export const SET_USER_ACCOUNT = 'SET_USER_ACCOUNT';

export const setUserAccount = createAction(SET_USER_ACCOUNT);
